/**
 * frontend/src/components/common/Footer.js
 * 
 * Global footer component used across the public and authenticated pages.
 * Displays navigation links, brand information, contact details, and legal links.
 */
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';
import logo from '../../assets/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { name: 'Features', href: '/#features' },
      { name: 'How it Works', href: '/#how-it-works' },
      { name: 'Pricing', href: '/pricing' },
    ],
    company: [
      { name: 'About', href: '/#' },
      { name: 'Contact Us', href: '/contact' },
      { name: 'Careers', href: '/#' },
    ],
    legal: [
      { name: 'Terms & Conditions', href: '/terms' },
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Refunds', href: '/refunds' },
    ],
    resources: [
      { name: 'Security', href: '/security' },
      { name: 'Documentation', href: '/#' },
      { name: 'Support', href: '/contact' },
    ],
  };

  return (
    <footer className="fat-footer">
      <Container>
        <Row className="footer-main">
          <Col lg={4} md={6} className="footer-brand-section">
            <Link to="/" className="footer-brand-link">
              <img src={logo} alt="ChangeFox" className="footer-logo-img" />
            </Link>
            <p className="footer-description">
              Streamline your compliance change management with our intuitive platform.
              Track requests, manage approvals, and maintain complete audit trails.
            </p>
            <div className="footer-contact">
              <FiMail />
              <a href="mailto:contact@changefox.ai">contact@changefox.ai</a>
            </div>
          </Col>

          <Col lg={2} md={6} sm={6} xs={6} className="footer-links-section">
            <h4 className="footer-heading">Product</h4>
            <ul className="footer-links">
              {footerLinks.product.map((link, index) => (
                <li key={index}>
                  <Link to={link.href}>{link.name}</Link>
                </li>
              ))}
            </ul>
          </Col>

          <Col lg={2} md={6} sm={6} xs={6} className="footer-links-section">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <Link to={link.href}>{link.name}</Link>
                </li>
              ))}
            </ul>
          </Col>

          <Col lg={2} md={6} sm={6} xs={6} className="footer-links-section">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <Link to={link.href}>{link.name}</Link>
                </li>
              ))}
            </ul>
          </Col>

          <Col lg={2} md={6} sm={6} xs={6} className="footer-links-section">
            <h4 className="footer-heading">Resources</h4>
            <ul className="footer-links">
              {footerLinks.resources.map((link, index) => (
                <li key={index}>
                  <Link to={link.href}>{link.name}</Link>
                </li>
              ))}
            </ul>
          </Col>
        </Row>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} ChangeFox. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/security">Security</Link>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
